/**
 * Created by motie on 17/11/08.
 */
export function convertDic(list, type) {
	let targetDicList = []
	for (let obj in list) {
		if (list[obj].type === type) {
			targetDicList = list[obj].dicObjList
		}
	}
	return targetDicList
}

/**
 * 获取用户cp数据字典
 * @param dicLists 数组字典list
 * @param dicId 5 cp 对应type
 * @param cpInfo 当前cp 信息
 * @returns {*}
 */
export function getCpInfo(dicLists, dicType, cpInfo) {
	let tempList = []
	let dicList = convertDic(dicLists, dicType)
	if (cpInfo.length == 0 || dicLists.length == 0) return
	let cpId = cpInfo[0].cpId
	if (cpId !== 0) {
		for (let i = 0; i < dicList.length; i++) {
			if (cpId == dicList[i].value) {
				tempList.push(dicList[i])
			}
		}
		if (tempList.length > 0) {
			return tempList
		}
	}
	return dicList
}

export function parseTime(time, cFormat) {
	if (arguments.length === 0) {
		return null
	}
	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if (('' + time).length === 10) time = parseInt(time) * 1000
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		if (key === 'a') return ['日', '一', '二', '三', '四', '五', '六'][value]
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

export function formatTime(time, option) {
	time = +time * 1000
	const d = new Date(time)
	const now = Date.now()

	const diff = (now - d) / 1000

	if (diff < 30) {
		return '刚刚'
	} else if (diff < 3600) { // less 1 hour
		return Math.ceil(diff / 60) + '分钟前'
	} else if (diff < 3600 * 24) {
		return Math.ceil(diff / 3600) + '小时前'
	} else if (diff < 3600 * 24 * 2) {
		return '1天前'
	}
	if (option) {
		return parseTime(time, option)
	} else {
		return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
	}
}

// 格式化时间
export function getQueryObject(url) {
	url = url == null ? window.location.href : url
	const search = url.substring(url.lastIndexOf('?') + 1)
	const obj = {}
	const reg = /([^?&=]+)=([^?&=]*)/g
	search.replace(reg, (rs, $1, $2) => {
		const name = decodeURIComponent($1)
		let val = decodeURIComponent($2)
		val = String(val)
		obj[name] = val
		return rs
	})
	return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
	let len = 0
	for (let i = 0; i < val.length; i++) {
		if (val[i].match(/[^\x00-\xff]/ig) != null) {
			len += 1
		} else {
			len += 0.5
		}
	}
	return Math.floor(len)
}

export function cleanArray(actual) {
	const newArray = []
	for (let i = 0; i < actual.length; i++) {
		if (actual[i]) {
			newArray.push(actual[i])
		}
	}
	return newArray
}

export function param(json) {
	if (!json) return ''
	return cleanArray(Object.keys(json).map(key => {
		if (json[key] === undefined) return ''
		return encodeURIComponent(key) + '=' +
			encodeURIComponent(json[key])
	})).join('&')
}

export function param2Obj(url) {
	const search = url.split('?')[1]
	if (!search) {
		return {}
	}
	return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function html2Text(val) {
	const div = document.createElement('div')
	div.innerHTML = val
	return div.textContent || div.innerText
}

export function objectMerge(target, source) {
	/* Merges two  objects,
     giving the last one precedence */

	if (typeof target !== 'object') {
		target = {}
	}
	if (Array.isArray(source)) {
		return source.slice()
	}
	for (const property in source) {
		if (source.hasOwnProperty(property)) {
			const sourceProperty = source[property]
			if (typeof sourceProperty === 'object') {
				target[property] = objectMerge(target[property], sourceProperty)
				continue
			}
			target[property] = sourceProperty
		}
	}
	return target
}

export function scrollTo(element, to, duration) {
	if (duration <= 0) return
	const difference = to - element.scrollTop
	const perTick = difference / duration * 10
	setTimeout(() => {
		element.scrollTop = element.scrollTop + perTick
		if (element.scrollTop === to) return
		scrollTo(element, to, duration - 10)
	}, 10)
}

export function toggleClass(element, className) {
	if (!element || !className) {
		return
	}
	let classString = element.className
	const nameIndex = classString.indexOf(className)
	if (nameIndex === -1) {
		classString += '' + className
	} else {
		classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
	}
	element.className = classString
}

export const pickerOptions = [
	{
		text: '今天',
		onClick(picker) {
			const end = new Date()
			const start = new Date(new Date().toDateString())
			end.setTime(start.getTime())
			picker.$emit('pick', [start, end])
		}
	}, {
		text: '最近一周',
		onClick(picker) {
			const end = new Date(new Date().toDateString())
			const start = new Date()
			start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
			picker.$emit('pick', [start, end])
		}
	}, {
		text: '最近一个月',
		onClick(picker) {
			const end = new Date(new Date().toDateString())
			const start = new Date()
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
			picker.$emit('pick', [start, end])
		}
	}, {
		text: '最近三个月',
		onClick(picker) {
			const end = new Date(new Date().toDateString())
			const start = new Date()
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
			picker.$emit('pick', [start, end])
		}
	}]

export function getTime(type) {
	if (type === 'start') {
		return new Date().getTime() - 3600 * 1000 * 24 * 90
	} else {
		return new Date(new Date().toDateString())
	}
}

export function debounce(func, wait, immediate) {
	let timeout, args, context, timestamp, result

	const later = function () {
		// 据上一次触发时间间隔
		const last = +new Date() - timestamp

		// 上次被包装函数被调用时间间隔last小于设定时间间隔wait
		if (last < wait && last > 0) {
			timeout = setTimeout(later, wait - last)
		} else {
			timeout = null
			// 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
			if (!immediate) {
				result = func.apply(context, args)
				if (!timeout) context = args = null
			}
		}
	}

	return function (...args) {
		context = this
		timestamp = +new Date()
		const callNow = immediate && !timeout
		// 如果延时不存在，重新设定延时
		if (!timeout) timeout = setTimeout(later, wait)
		if (callNow) {
			result = func.apply(context, args)
			context = args = null
		}

		return result
	}
}

export function deepClone(source) {
	if (!source && typeof source !== 'object') {
		throw new Error('error arguments', 'shallowClone')
	}
	const targetObj = source.constructor === Array ? [] : {}
	for (const keys in source) {
		if (source.hasOwnProperty(keys)) {
			if (source[keys] && typeof source[keys] === 'object') {
				targetObj[keys] = source[keys].constructor === Array ? [] : {}
				targetObj[keys] = deepClone(source[keys])
			} else {
				targetObj[keys] = source[keys]
			}
		}
	}
	return targetObj
}

/**
 * 递归树
 * @param data
 * @param pid
 * @returns {Array}
 */
export function sonsTree(data, pid) {
	var result = [], temp
	for (var i in data) {
		if (data[i].parentId == pid) {
			result.push(data[i])
			temp = sonsTree(data, data[i].id)
			if (temp.length > 0) {
				data[i].children = temp
			}
		}
	}
	return result
}

export function getCapthUrl(url) {
	return process.env.AUTH_API + url
}

/**
 * 比较对象差异
 * @param obj1  object array
 * @param obj2  object array
 * @returns true 有差异   false  没有差异
 */
function type(o) {
	var s = Object.prototype.toString.call(o)
	return s.slice(s.indexOf(' ') + 1, s.length - 1).toLowerCase()
}

export function compareSimpleObject(origin, target) {
	if (typeof target === 'object' && target != null) {
		if (typeof origin !== 'object' && origin == null) return false
		let tempObject = Object.keys(origin).length > Object.keys(target).length ? Object.keys(origin) : Object.keys(target)
		for (let key of tempObject) {
			if (!compareSimpleObject(origin[key], target[key])) return false
		}
		return true
	} else {
		return origin === target
	}
}

/**
 * 获取地址栏参数
 * @param name
 * @returns {null}
 */
export function getQueryString(name) {
	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
	var r = window.location.href.match(reg)
	if (r != null) return unescape(r[2])
	return null
}

/**
 * 获取中英文字符串
 * @param str
 * @return {isZh:是否完全中文,Len:字节长度}
 */
export function getStrLength(str) {
	var tmp = 0
	var len = 0
	var flag = true
	for (var i = 0; i < str.length; i++) {
		if (str.charCodeAt(i) > 255) {
			tmp += 2
		} else {
			flag = false
			len += 1
		}
	}
	return {isZh: flag, len: tmp + len}
}

// 合并单元格
/* mergeNum合并列数量，mergeRow从第几行合并 */
export function MergeCell(list, mergeValue) {
	console.log(mergeValue)
	if (!list) {
		return []
	}
	let arr = list, obj = {}
	for (let i = 0; i < arr.length; i++) {
		let dt = arr[i].publishDate
		if (obj[dt]) {
			obj[dt]++
			arr[i].mergeNum = 0
		} else {
			arr[i].mergeRow = true
			obj[dt] = 1
		}
	}
	arr.forEach((item) => {
		if (item.mergeRow) {
			item.mergeNum = obj[item.publishDate]
		}
	})
	// console.log(list)
	return arr
}

export function removeClass(el, cls) {
	if (!el || !cls) return
	var classes = cls.split(' ')
	var curClass = ' ' + el.className + ' '

	for (var i = 0, j = classes.length; i < j; i++) {
		var clsName = classes[i]
		if (!clsName) continue

		if (el.classList) {
			el.classList.remove(clsName)
		} else if (hasClass(el, clsName)) {
			curClass = curClass.replace(' ' + clsName + ' ', ' ')
		}
	}
	if (!el.classList) {
		el.className = trim(curClass)
	}
}

export function addClass(el, cls) {
	if (!el) return
	var curClass = el.className
	var classes = (cls || '').split(' ')

	for (var i = 0, j = classes.length; i < j; i++) {
		var clsName = classes[i]
		if (!clsName) continue

		if (el.classList) {
			el.classList.add(clsName)
		} else if (!hasClass(el, clsName)) {
			curClass += ' ' + clsName
		}
	}
	if (!el.classList) {
		el.className = curClass
	}
}

export function getHost(url) {
	return url.replace(/:\/\/(.*?)\//, '$1')
}

export function timeFilter(val) {
	let yearn = val.substring(0, val.indexOf('-'))
	let months = val.substring(val.lastIndexOf('-') + 1)
	months < 10 ? months = months.substring(1) : months
	return `${yearn}年${months}月`
}

const motieHost = 'www.laikan.com'
const mmHost = 'mm.laikan.com'
const yyHost = 'yynovel.laikan.com'
const zuitangHost = 'zuitang.laikan.com'
const jwHost = 'jw.laikan.com'

// 根据cp ，生成书籍跳转url
// 该方法主要解决部分作者的书籍的cp是不统一的
export function getHostByCp(cp) {
	let protocol = location.protocol

	let temp = ''

	if (cp === 1 || cp === 8) {
		temp = motieHost
	} else if (cp === 2) {
		temp = mmHost
	} else if (cp === 4) {
		temp = yyHost
	} else if (cp === 5) {
		temp = jwHost
	} else if (cp === 6) {
		temp = zuitangHost
	}

	return temp ? protocol + '//' + temp : protocol + '//' + 'www.laikan.com'
}



// WEBPACK FOOTER //
// ./src/utils/index.js